import React from 'react'
import { Bar } from 'react-chartjs-2';
import dayjs from '../../utils/dayjs';

const Harian = (props) => {
    const daily = props.data;
    const getDay = (string) => {
        return dayjs(string).format('D MMM');
    }
    return (
        <div className='card'>
            <header className='card-header'>
                <p className='card-header-title is-size-7'>Harian</p>
            </header>
            <div className='card-content'>
                <Bar
                    data={{
                        labels: daily.map((item) => getDay(item.date)),
                        datasets: [
                            {
                                axis: 'y',
                                label: "Masuk",
                                data: daily.map((item) => item.debit),
                                barThickness: 7,
                                backgroundColor: 'rgba(0,0,255,0.5)',
                            },
                            {
                                axis: 'y',
                                label: "Keluar",
                                data: daily.map((item) => item.kredit),
                                barThickness: 7,
                                backgroundColor: 'rgba(255,0,0,0.5)',
                            }
                        ],
                    }}
                    options={{
                        responsive: true,
                        indexAxis: 'y',
                        maintainAspectRatio: false,
                        scales: {
                            y: {
                                title: {
                                    display: true,
                                    text: 'Tanggal'
                                },
                                ticks: {
                                    // forces step size to be 50 units
                                    //stepSize: 500,
                                }
                            },
                            x: {
                                ticks: {
                                    // forces step size to be 50 units
                                    //stepSize: 500,
                                }
                            }
                        },
                        plugins: {
                            legend: {
                                position: 'bottom',
                            },
                        },
                    }}
                    height={700}
                />

            </div>
        </div>
    )
}

export default Harian
